import Vue from 'vue';
import VueRouter from 'vue-router';
import { staticRoutes } from './routerConfig';
import userService from '@/components/service/UserService';
import { usePremissionStore } from '@/pinia/permission';
import { useTagViewStore } from '@/pinia/tagView';
import { setTitle, checkVersion } from '@/utils/index';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  routes: [...staticRoutes],
  scrollBehavior: () => ({ y: 0 }),
})

// 路由跳转白名单
const whiteList = ['Login'];

router.beforeEach(async(to, from, next) => {
  if (to.meta && to.meta.title) setTitle(to.meta.title);
  const token = userService.getToken();

  if (token) { // 用户已登录
    const premissionStore = usePremissionStore();
    if (to.name === 'Login') { // 访问登录页
      next('/');
    } else if (premissionStore.routes.length === 0) { // 首次进入主页面
      // 获取用户角色，`authority（0管理员 1普通用户 2超级管理员 3园林绿化局管理员）`
      const { role, deptType } = userService.getUser();
      const userRole = {
        role: role.authority,
        deptType,
      };
      try {
        // 根据用户角色生成路由列表
        const addRoutes = await premissionStore.generateRoutes(userRole);
        // 动态添加路由
        addRoutes.forEach((r) => {
          router.addRoute(r);
        });
        next({ path: to.path, query: to.query, replace: true });
      } catch (error) {
        window.location.reload();
      }
    } else {
      // 路由加载前，缓存页面
      // 1、如果 to.keeplive 存在，则表示该页面需要缓存
      if (to.meta.keepAlive) {
        useTagViewStore().addCacheView(to);
      } else if (from.meta.keepAlive) {
        // 2、如果 from.keeplive 存在，则判断 to.name 是否在 from.keeplive 中，如果存在，则缓存 from 页面，否则删除 from 页面
        if (from.meta.keepAlive.includes(to.name)) {
          useTagViewStore().addCacheView(from);
        } else {
          useTagViewStore().delCacheView(from);
        }
      } else {
        // 3、如果 form 和 to 都不需要缓存，则清空缓存
        useTagViewStore().clearCacheViews();
      }
      next();
    }
  } else {
    if (whiteList.includes(to.name)) {
      next();
    } else {
      next('/login');
    }
  }
})

// 判断 version 是否是最新版本
router.afterEach((to) => {
  checkVersion();
});

// 重置路由（用户退出登录时调用，避免不同用户登录后路由不更新问题）
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher;
}

// 捕获到 Loading chunk {n} failed 的错误时，重新渲染目标页面
router.onError((error) => {
  const pattern = /Loading .*failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) router.replace(targetPath);
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js